module.exports = __webpack_public_path__ + "static/img/rujia.86019d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/partners/rujia.png
// module id = IOB9
// module chunks = 3